import { render, staticRenderFns } from "./ClientInfoPanel.vue?vue&type=template&id=02b5f14a&scoped=true&"
import script from "./ClientInfoPanel.vue?vue&type=script&lang=js&"
export * from "./ClientInfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./ClientInfoPanel.vue?vue&type=style&index=0&id=02b5f14a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b5f14a",
  null
  
)

export default component.exports